import { z } from 'zod';

/**
 * Enum representing the direction of a message, either inbound or outbound.
 */
export const MessageDirectionEnum = z.enum(['inbound', 'outbound']);

/**
 * Enum representing the status of a message, such as pending, sent, delivered, failed, read, or received.
 */
export const MessageStatusEnum = z.enum([
  'pending', // message sent to provider
  'queued', // message queued for delivery on the provider
  'sent', // message sent from provider
  'delivered', // message delivered to recipient
  'failed', // message failed to be delivered
  'read', // message read by recipient
  'received', // message received by recipient
]);
export const MessageTypeEnum = z.enum(['text', 'media', 'document', 'other']);

export type MessageStatus = z.infer<typeof MessageStatusEnum>;

/**
 * Enum representing the available communication channels (providers), such as SMS, email, Slack, WhatsApp, and Instagram.
 */
export const communicationChannelEnum = z.enum([
  'sms',
  'email',
  'slack',
  'whatsapp',
  'instagram',
]);

export type CommunicationChannelEnum = z.infer<typeof communicationChannelEnum>;
